const GearStocksCell = ({ stocks }) => {
  if (!stocks) return "-";

  return (
    <div className="whitespace-nowrap">
      {stocks.map((s, index) => (
        <div key={index}>
          {s.warehouseName}: {s.qty}
        </div>
      ))}
    </div>
  );
};

export default GearStocksCell;
